/**
 * Calendar-day arithmetic on 'YYYY-MM-DD' strings, DST-proof: every date is
 * handled at UTC noon, so adding a day across a clock change can never land on
 * the same date twice or skip one.
 */

const MS_DAY = 86_400_000

function noon(day: string): number {
  const [y, m, d] = day.split('-').map(Number)
  return Date.UTC(y, m - 1, d, 12)
}

function fmt(ms: number): string {
  const d = new Date(ms)
  return `${d.getUTCFullYear()}-${String(d.getUTCMonth() + 1).padStart(2, '0')}-` +
    `${String(d.getUTCDate()).padStart(2, '0')}`
}

export function addDays(day: string, n: number): string {
  return fmt(noon(day) + n * MS_DAY)
}

/** b - a in whole days. */
export function daysBetween(a: string, b: string): number {
  return Math.round((noon(b) - noon(a)) / MS_DAY)
}

export function dayRange(from: string, to: string): string[] {
  const out: string[] = []
  const n = daysBetween(from, to)
  for (let i = 0; i <= n; i++) out.push(addDays(from, i))
  return out
}

/** 0 = Monday … 6 = Sunday. */
export function weekday(day: string): number {
  return (new Date(noon(day)).getUTCDay() + 6) % 7
}

export function mondayOf(day: string): string {
  return addDays(day, -weekday(day))
}

export function ageOn(birth: string, day: string): number {
  const [by, bm, bd] = birth.split('-').map(Number)
  const [y, m, d] = day.split('-').map(Number)
  let age = y - by
  if (m < bm || (m === bm && d < bd)) age--
  return age
}

export function shortDate(day: string): string {
  const [y, m, d] = day.split('-').map(Number)
  return new Date(Date.UTC(y, m - 1, d, 12)).toLocaleDateString('en-CA',
    { month: 'short', day: 'numeric', timeZone: 'UTC' })
}
